import { gql } from "@apollo/client";

// 查询账单列表
export const GET_BILL_LISTING = gql`
  query GetBillListing($filters: BillFiltersInput, $pageRequest: PageRequestTypeInput) {
    getBillListing(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        clientName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        isSent
        invoiceStatus
        invoiceSubmitted
        invoiceEligible
        invoiceAmount
        invoiceCurrency
        invoiceAmountMismatch
        settlementCadence
        dspFullName
        periodStart
        periodEnd
        timeZone
        createdAt
        updatedAt
        isCanceled
        canRerun
        __typename
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
        __typename
      }
      summary {
        customerCount
        billCount
        totalAmount
        __typename
      }
      __typename
    }
  }
`;

/** Delivery DSP Manager：仅本账号绑定 DSP 的 DSP 运费账单列表 */
export const GET_DELIVERY_DSP_BILL_LISTING = gql`
  query GetDeliveryDspBillListing($filters: BillFiltersInput, $pageRequest: PageRequestTypeInput) {
    getDeliveryDspBillListing(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        clientName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        isSent
        invoiceStatus
        invoiceSubmitted
        invoiceAmount
        invoiceCurrency
        invoiceAmountMismatch
        settlementCadence
        periodStart
        periodEnd
        timeZone
        createdAt
        updatedAt
        isCanceled
        canRerun
        __typename
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
        __typename
      }
      summary {
        customerCount
        billCount
        totalAmount
        __typename
      }
      __typename
    }
  }
`;

/** WMS Hub Manager：仅本 Hub 关联 DSP 的 DSP 运费账单列表 */
export const GET_WMS_HUB_DSP_BILL_LISTING = gql`
  query GetWmsHubDspBillListing($hubId: Long!, $filters: BillFiltersInput, $pageRequest: PageRequestTypeInput) {
    getWmsHubDspBillListing(hubId: $hubId, filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        clientName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        isSent
        invoiceStatus
        invoiceSubmitted
        invoiceAmount
        invoiceCurrency
        invoiceAmountMismatch
        settlementCadence
        periodStart
        periodEnd
        timeZone
        createdAt
        updatedAt
        isCanceled
        canRerun
        __typename
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
        __typename
      }
      summary {
        customerCount
        billCount
        totalAmount
        __typename
      }
      __typename
    }
  }
`;

// 查询账单重跑历史
export const GET_BILL_RERUN_HISTORY = gql`
  query GetBillRerunHistory($clientId: ID, $pageRequest: PageRequestTypeInput) {
    getBillRerunHistory(clientId: $clientId, pageRequest: $pageRequest) {
      content {
        originalBillId
        newBillId
        clientId
        clientName
        periodInstanceId
        billType
        periodStart
        periodEnd
        reason
        errorMessage
        createdAt
        completedAt
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

// 查询可重跑的账期实例
export const GET_RERUNNABLE_PERIOD_INSTANCES = gql`
  query GetRerunnablePeriodInstances($clientId: ID, $pageRequest: PageRequestTypeInput, $includeCancelled: Boolean) {
    getRerunnablePeriodInstances(clientId: $clientId, pageRequest: $pageRequest, includeCancelled: $includeCancelled) {
      content {
        id
        clientId
        clientName
        billType
        periodStart
        periodEnd
        timeZone
        status
        canRerun
        isIssued
      }
      pageInfo {
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

// 查询账期规则详情
export const GET_BILLING_PERIOD_RULE_DETAIL = gql`
  query GetBillingPeriodRuleDetail($ruleId: Long!) {
    getBillingPeriodRuleById(ruleId: $ruleId) {
      id
      status
      __typename
    }
  }
`;

// 查询账期实例详情（获取规则ID）
export const GET_BILLING_PERIOD_INSTANCE_DETAIL = gql`
  query GetBillingPeriodInstanceDetail($instanceId: Long!) {
    getBillingPeriodInstanceById(instanceId: $instanceId) {
      id
      ruleId
      __typename
    }
  }
`;

// 查询账期实例关联的最新账单
export const GET_LATEST_BILL_BY_PERIOD_INSTANCE = gql`
  query GetLatestBillByPeriodInstance($periodInstanceId: ID!) {
    getLatestBillByPeriodInstance(periodInstanceId: $periodInstanceId) {
      id
      billingPeriodInstanceId
      clientName
      clientId
      billType
      status
      billAmount
      periodStart
      periodEnd
      timeZone
      createdAt
      updatedAt
      isCanceled
      canRerun
      __typename
    }
  }
`;

// 获取所有客户列表
export const GET_ALL_CLIENTS = gql`
  query GetAllClients {
    getAllClients {
      clientId
      clientName
      displayName
    }
  }
`;

// 获取当前操作人可用的账单状态筛选项
export const GET_BILL_STATUS_FILTER_OPTIONS = gql`
  query GetBillStatusFilterOptions {
    getBillStatusFilterOptions {
      value
      label
    }
  }
`;

export const GET_DSP_BILL_STATUS_FILTER_OPTIONS_FOR_INTERNAL = gql`
  query GetDspBillStatusFilterOptionsForInternal {
    getDspBillStatusFilterOptionsForInternal {
      value
      label
    }
  }
`;

// 查询账单详情
export const GET_BILL_DETAIL = gql`
  query GetBillDetail($billId: ID!) {
    getBillDetail(billId: $billId) {
      bill {
        id
        billingPeriodInstanceId
        clientName
        dspFullName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        currency
        periodStart
        periodEnd
        timeZone
        isCanceled
        isSent
        lastSentAt
        invoiceStatus
        invoiceEligible
        settlementCadence
        createdAt
        updatedAt
      }
      feeSummaries {
        feeItemId
        feeItemName
        totalAmount
        amountSign
        allowAdjustment
      }
      adjustmentRecords {
        taskId
        adjustmentType
        adjustmentAmount
        reason
        submitterId
        submitterName
        submittedAt
        status
      }
    }
  }
`;

// HUB MANAGER 查询 DSP 账单详情（含 Hub 归属校验）
export const GET_HUB_MANAGER_BILL_DETAIL = gql`
  query GetHubManagerBillDetail($hubId: Long!, $billId: ID!) {
    getHubManagerBillDetail(hubId: $hubId, billId: $billId) {
      bill {
        id
        billingPeriodInstanceId
        clientName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        currency
        periodStart
        periodEnd
        timeZone
        isCanceled
        isSent
        lastSentAt
        invoiceEligible
        settlementCadence
        createdAt
        updatedAt
      }
      feeSummaries {
        feeItemId
        feeItemName
        totalAmount
        amountSign
        allowAdjustment
      }
      adjustmentRecords {
        taskId
        adjustmentType
        adjustmentAmount
        reason
        submitterId
        submitterName
        submittedAt
        status
      }
    }
  }
`;

// DSP MANAGER：Delivery DSP 账单详情（含绑定 DSP 归属校验）
export const GET_DELIVERY_DSP_BILL_DETAIL = gql`
  query GetDeliveryDspBillDetail($billId: ID!) {
    getDeliveryDspBillDetail(billId: $billId) {
      bill {
        id
        billingPeriodInstanceId
        clientName
        clientId
        channelId
        billType
        status
        billAmount
        orderCount
        currency
        periodStart
        periodEnd
        timeZone
        isCanceled
        isSent
        lastSentAt
        invoiceEligible
        invoiceSubmitted
        rejectReason
        settlementCadence
        createdAt
        updatedAt
      }
      feeSummaries {
        feeItemId
        feeItemName
        totalAmount
        amountSign
        allowAdjustment
      }
      adjustmentRecords {
        taskId
        adjustmentType
        adjustmentAmount
        reason
        submitterId
        submitterName
        submittedAt
        status
      }
    }
  }
`;

// 查询账单状态流转记录
export const GET_BILL_STATUS_TRANSITION_RECORDS = gql`
  query GetBillStatusTransitionRecords($billId: ID!) {
    getBillStatusTransitionRecords(billId: $billId) {
      id
      billId
      fromStatus
      fromStatusLabel
      toStatus
      toStatusLabel
      operatorId
      operatorName
      remark
      attachmentObjectKey
      attachmentDownloadUrl
      createdAt
    }
  }
`;

export const CHECK_DSP_EXPORT_READINESS = gql`
  query CheckDspExportReadiness($dspIds: [Long!], $billTimeRange: BillTimeRangeInput) {
    checkDspExportReadiness(dspIds: $dspIds, billTimeRange: $billTimeRange) {
      canExport
      blockingBillIds
    }
  }
`;

export const CHECK_DSP_BILLS_ADJUST_READINESS = gql`
  query CheckDspBillsAdjustReadiness($billIds: [Long!]!) {
    checkDspBillsAdjustReadiness(billIds: $billIds)
  }
`;
